module.exports = "/images/ic-girl-01.jpg?1a9db9719373e8d6bab11ccc22231107";